export const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
    },
    guidelineItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    },
    additionalHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
    expandIcon: (expanded: boolean) => ({
        transform: expanded ? 'rotate(180deg)' : 'none',
        transition: 'transform 0.2s',
    }),
    searchField: {
        mb: 1,
    },
    scrollableList: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        maxHeight: '300px',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '4px',
            '&:hover': {
                background: '#555',
            },
        },
    },
    promptItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
    checkbox: {
        border: 'none',
    },
    launchButton: {
        ml: 'auto',
    },
} as const;
